import useSWR from 'swr';
import { useContext } from 'react';
import { FixtureStream } from '@/service/types';
import { ScoringContext } from '@/contexts/scoring/context';
import { useAuthToken } from '@/contexts/auth/useAuthToken';
import {
  SERVICE_ENDPOINT,
  fetchFromMTService,
} from '../fetcher/monitoringToolService';
import { HTTP_STATUS_CODE } from '../constants';
import { ApiError } from '../ApiError';

interface UseStreamingProps {
  isStreamSport: boolean;
}

export const useStreaming = ({ isStreamSport }: UseStreamingProps) => {
  const token = useAuthToken();
  const {
    state: { fixtureId },
  } = useContext(ScoringContext);
  const { data, error } = useSWR<FixtureStream, ApiError>(
    fixtureId && token && isStreamSport
      ? {
          token,
          endpoint: SERVICE_ENDPOINT.Streaming(fixtureId).streaming.GET,
        }
      : null,
    fetchFromMTService,
    {
      onErrorRetry: (e, _, config, revalidate, { retryCount }) => {
        if (e.status === HTTP_STATUS_CODE.NOT_FOUND) return;
        if (e.status === HTTP_STATUS_CODE.UNAUTHORIZED) return;
        setTimeout(() => revalidate({ retryCount }), config.errorRetryInterval);
      },
      revalidateOnFocus: false,
    },
  );

  return {
    liveStreamUrl: data?.liveStream,
    archivedStreamUrl: data?.archivedStream,
    streamStartDateTime: data?.streamStartDateTime,
    error,
    isLoading: !data && !error,
  };
};
